import React from "react";
import { Col, Row } from "react-bootstrap";

const AboutChild_Interests = (props) => {
  let Int_Array = [
    "Software Development",
    "Third-Party API Integration",
    "SDK Integration",
    // "Sports Analytics",
    "Adventure Travel",
    "Tech Exploration",
    "Knowledge Sharing",
    "Cloud Computing",
    "Machine Learning & AI",
    // "Cybersecurity Innovations",
  ];

  return (
    <>
      <h2 className="m-0 pb-3">My Interests</h2>
      <hr />
      {Int_Array?.map((item, index) => (
        <>
          <Row className="py-2">
            <Col md={12}>
              <h6 className="m-0 title-primary">{item}</h6>
            </Col>
          </Row>
          <hr />
        </>
      ))}
    </>
  );
};

export default AboutChild_Interests;
